export default {
  'onboarding.sectionTitle': 'Onboarding Checklist',
  'onboarding.menuTitle': 'Onboarding',
  'onboarding.title': 'Onboarding',
  'onboardingForm.saveButton': 'Save',
  'onboardingForm.backToChecklistButton': 'Back to checklist',
  'onboardingForm.error.title.saving': 'Saving Error',
  'onboardingForm.error.title.loading': 'Loading Error',
  'onboardingForm.success.title.saving': 'Changes saved',
  'onboardingForm.success.message.saving': 'Your changes have been saved successfully.',
  'onboarding.header': 'Onboarding checklist',
  'onboarding.list.item.start': 'Start',
  'onboarding.merchant.title': 'Onboarding > Merchant Information',
  'onboarding.business.title': 'Onboarding > Business Information',
  'onboarding.store.title': 'Onboarding > Store Information',
  'onboarding.bank.title': 'Onboarding > Bank Information',
};
